// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-view-redemption {
  padding: 0 var(--spacing-regular);
  margin-top: var(--spacing-big);
}
.container-title-view-redemption {
  margin-bottom: var(--spacing-big);
}
.container-button-view-redemption {
  margin-bottom: var(--spacing-big);
}
.container-subtitle-view-redemption {
  display: flex;
  flex-direction: row;
  margin-bottom: var(--spacing-big);
  justify-content: start;
  align-items: center;
}
.shipping-free-value {
  color: var(--color-highlight);
}
.container-loading {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  width: 100%;
}
.title-view-redemption {
  font-size: var(--font-giant);
  font-weight: bold;
  color: var(--color-neutral-dark-darker);
}
.subtitle-view-redemption {
  font-size: var(--font-giant);
  font-weight: 500;
  color: var(--color-neutral-dark-darker);
}
.container-summary-view-redemption {
  margin-bottom: var(--spacing-big);
}
.text-view-redemption {
  font-size: var(--font-medium);
}
.text-history-description {
  color: var(--color-detached);
  font-size: var(--font-paragraph);
}
.link-view-redemption {
  color: #63717a !important;
  font-size: var(--font-medium);
}
.link-view-redemption:hover {
  color: #acc4d3 !important;
}
.font-weight-700 {
  font-weight: 700;
}
.font-weight-bolder {
  font-weight: bolder;
}
.spacing-icon {
  margin-right: var(--spacing-small);
  transform: scale(1.5);
}
.spacing-icon span svg {
  fill: var(--color-detached) !important;
}
.container-details-view-redemption {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.icon-pdf-orcament {
  color: var(--color-detached);
  font-size: var(--font-giant);
  font-weight: 700;
}
.line-cancel {
  border-color: var(--error-color) !important;
}
.line-pending {
  border-color: var(--color-warning) !important;
}
.line-updated {
  border-color: var(--color-secondary) !important;
}
.line-approved {
  border-color: var(--color-success) !important;
}
.status-cancel {
  color: var(--error-color) !important;
}
.status-pending {
  color: var(--color-warning) !important;
}
.status-updated {
  color: var(--color-secondary) !important;
}
.status-approved {
  color: var(--color-success) !important;
}
.text-spot-not-found {
  font-size: var(--font-medium);
  color: var(--color-neutral-dark);
  margin-top: var(--spacing-regular);
  margin-bottom: var(--spacing-regular);
}
.container-spot-not-found {
  display: flex;
  flex-direction: column;
}
.container-history {
  background-color: var(--color-neutral-light-lighter);
  border-radius: var(--border-radius-primary);
  padding: var(--spacing-small);
  color: var(--color-secondary);
  max-height: 350px;
  overflow-y: auto;
  padding: var(--spacing-regular);
  margin-bottom: var(--spacing-big);
  position: relative;
}
.history-status {
  font-weight: 900;
  width: 120px;
  font-size: var(--font-medium);
  white-space: nowrap;
  margin-right: var(--spacing-big);
}
.container-history-date {
  margin-left: 12px;
  padding-left: 12px;
  border-left: 1px solid var(--color-detached);
}
.text-history-date {
  font-weight: 900;
  color: var(--color-detached);
  font-size: var(--font-medium);
}
.history-type {
  font-size: var(--font-paragraph);
  margin-left: var(--spacing-small);
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-total-value {
  font-size: var(--font-giant);
  font-weight: 700;
}
.container-total-value {
  margin-top: var(--spacing-regular);
  margin-bottom: var(--spacing-regular);
}
.button-view-redemption {
  width: 100%;
}
.row-button {
  margin-top: var(--spacing-big);
}
.history-timeline {
  padding-bottom: var(--spacing-small);
  border-left: 2px solid var(--color-secondary);
  padding-left: var(--spacing-small);
}
.history-timeline:before {
  content: '';
  height: var(--spacing-small);
  width: var(--spacing-small);
  background-color: var(--color-secondary) !important;
  border-radius: 50%;
  position: absolute;
  margin-left: -25px;
}
.history-timeline-cancel {
  border-left: 2px solid var(--error-color);
}
.history-timeline-cancel:before {
  background-color: var(--error-color) !important;
}
.history-timeline-pending {
  border-left: 2px solid var(--color-warning);
}
.history-timeline-pending:before {
  background-color: var(--color-warning) !important;
}
.history-timeline-updated {
  border-left: 2px solid var(--color-secondary);
}
.history-timeline-updated:before {
  background-color: var(--color-secondary) !important;
}
.history-timeline-approved {
  border-left: 2px solid var(--color-success);
}
.history-timeline-approved:before {
  background-color: var(--color-success) !important;
}
.col-total-value {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: end;
}
.title-terms-aprovation {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: var(--spacing-small);
  width: 100%;
  margin: var(--spacing-small) 0;
}
.box-terms-aprovation-upload {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: var(--spacing-small);
  margin-top: var(--spacing-small);
}
.modal-terms-aprovation {
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-terms-aprovation {
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-terms-modal-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.button-view-redemption-danger {
  height: var(--form-item-height);
  padding: var(--button-padding);
  max-height: var(--form-item-height);
  font-size: var(--font-paragraph);
  line-height: 120%;
  font-family: var(--font-family);
  border-radius: var(--border-radius-primary);
  font-weight: 700;
  width: 100%;
}
.button-view-redemption-warning {
  height: var(--form-item-height);
  padding: var(--button-padding);
  max-height: var(--form-item-height);
  font-size: var(--font-paragraph);
  line-height: 120%;
  font-family: var(--font-family);
  border-radius: var(--border-radius-primary);
  font-weight: 700;
  width: 100%;
}
.modal-title {
  font-weight: 600;
}
.modal-text-area {
  min-height: 100px !important;
  border-radius: var(--border-radius-primary);
  border: 1px solid var(--color-neutral-light);
  padding: var(--spacing-small);
}
.modal-text-area::placeholder {
  font-family: var(--font-family);
  font-size: var(--font-paragraph);
  color: var(--color-neutral-light);
  font-weight: 400;
}
.blocked-text {
  background-color: #dcdcdc;
  pointer-events: none;
  text-decoration: line-through;
}
.row-undelivered {
  opacity: 0.5;
  pointer-events: none;
  text-decoration: line-through;
}
@media screen and (max-width: 768px) {
  .col-total-value {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: end;
  }
}
@media screen and (max-width: 576px) {
  .container-history-status-date {
    width: 50%;
  }
  .container-redemption-status {
    width: 50%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media screen and (max-width: 480px) {
  .container-view-redemption {
    margin-top: var(--spacing-small);
  }
  .container-title-view-redemption {
    margin-bottom: var(--spacing-small);
  }
  .container-history-status-date {
    width: 60%;
  }
  .container-redemption-status {
    width: 40%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.modal-spot-tracking-wrapper .ant-modal-content {
  max-height: 600px;
  overflow-y: auto;
  border-radius: var(--border-radius-primary);
}
.modal-spot-tracking-wrapper .ant-modal-content::-webkit-scrollbar {
  width: 8px;
}
.modal-spot-tracking-wrapper .ant-modal-content::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}
.modal-spot-tracking-wrapper .ant-modal-content::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  border-radius: 4px;
}
.modal-spot-tracking-wrapper .ant-modal-content::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
.modal-spot-tracking-wrapper .ant-modal-title {
  padding: 0 var(--spacing-small);
}
.modal-spot-tracking-wrapper .ant-modal-title .modal-title-spot-tracking {
  font-size: var(--font-paragraph) !important;
  color: var(--color-neutral-light) !important;
}
.modal-spot-tracking-wrapper .ant-modal-title .ant-divider-horizontal {
  margin: var(--spacing-small) 0 !important;
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
  padding: 0 var(--spacing-small);
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-number-and-status {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .order-number {
  color: var(--color-neutral-dark) !important;
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-infos {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-small);
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-infos .tracking-spot-info {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 1px solid var(--color-neutral-light);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-infos .tracking-spot-info img {
  object-fit: cover;
  overflow: hidden;
  max-width: 100%;
  max-height: 100%;
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-infos .tracking-spot-info-details {
  display: flex;
  flex-direction: column;
  gap: var(--spacing--extra-small);
  justify-content: center;
  align-items: flex-start;
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-infos .tracking-spot-info-details .tracking-spot-info-title {
  font-size: var(--font-paragraph);
  font-weight: 700;
  color: var(--color-neutral-dark) !important;
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-infos .tracking-spot-info-details .item-vendor {
  font-size: var(--font-paragraph);
  font-weight: 400 !important;
  color: var(--color-neutral-dark) !important;
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-infos .tracking-spot-info-details .item-code {
  font-size: var(--font-paragraph);
  font-weight: 700 !important;
  color: var(--color-neutral-dark) !important;
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-infos .tracking-spot-info-details .item-code .item-code-link {
  color: var(--color-highlight) !important;
  font-weight: 400 !important;
  text-decoration: underline;
  margin-left: var(--spacing-extra-small);
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-infos .tracking-spot-info-details .item-code .item-code-text {
  color: var(--color-neutral-dark) !important;
  font-weight: 400 !important;
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-infos .tracking-spot-info-details .item-shipping-value {
  color: var(--color-neutral-dark) !important;
  font-size: var(--font-paragraph);
  font-weight: 700 !important;
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-infos .tracking-spot-info-details .item-shipping-value span {
  color: var(--color-highlight) !important;
  margin-left: var(--spacing-extra-small);
  font-weight: 500 !important;
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-infos .tracking-spot-info-details .tracking-spot-info-subtitle {
  font-size: var(--font-paragraph);
  font-weight: 400;
  color: var(--color-neutral-light);
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-delivery-forecast {
  margin: var(--spacing-extra-small) 0;
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-delivery-forecast .delivery-forecast-title {
  font-size: var(--font-paragraph);
  font-weight: 700 !important;
  color: var(--color-neutral-dark) !important;
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-details {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
}
.modal-spot-tracking-wrapper .container-modal-spot-tracking .tracking-details .tracking-details-title {
  font-size: var(--font-paragraph);
  font-weight: 700 !important;
  color: var(--color-neutral-dark) !important;
}
.timeline {
  background: #fff;
  border-radius: 8px;
}
.timeline .timeline-item {
  margin: var(--spacing-small) 0;
}
.timeline .ant-timeline-item-head-green .timeline-icon-success {
  color: var(--color-success) !important;
  font-size: 16px;
}
.timeline .ant-timeline-item-head-gray {
  background-color: #d9d9d9;
}
.timeline .ant-timeline-item-content {
  color: #bfbfbf;
}
.timeline .ant-timeline-item-content .timeline-title {
  color: #bfbfbf;
  font-size: 14px !important;
}
.timeline-title {
  font-size: 16px;
  font-weight: 700 !important;
  color: var(--color-neutral-dark) !important;
}
.timeline-title.pending {
  color: var(--color-warning) !important;
}
.timeline-title.approved {
  color: var(--color-success) !important;
}
.timeline-title.updated {
  color: var(--color-secondary) !important;
}
.timeline-title.cancel {
  color: var(--error-color) !important;
}
.timeline-title.default {
  color: var(--color-success) !important;
}
.timeline-description {
  font-size: var(--font-paragraph);
  color: var(--color-neutral-dark-darker) !important;
  font-weight: 500 !important;
  margin-left: var(--spacing-small);
}
.timeline-description.default {
  color: var(--color-neutral-light) !important;
}
.timeline-date {
  font-size: 14px;
  color: #888;
}
.visible-hidden-tracking {
  visibility: hidden;
}
.order-status-tracking {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0 var(--spacing-small);
}
.order-status-tracking.pending {
  color: var(--color-warning) !important;
}
.order-status-tracking.approved {
  color: var(--color-success) !important;
}
.order-status-tracking.updated {
  color: var(--color-secondary) !important;
}
.order-status-tracking.cancel {
  color: var(--error-color) !important;
}
.order-status-tracking.default {
  color: var(--color-neutral-dark) !important;
}
.order-status-tracking .dot-status {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.order-status-tracking .dot-status.pending {
  background-color: var(--color-warning);
}
.order-status-tracking .dot-status.approved {
  background-color: var(--color-success);
}
.order-status-tracking .dot-status.updated {
  background-color: var(--color-secondary);
}
.order-status-tracking .dot-status.cancel {
  background-color: var(--error-color);
}
.order-status-tracking .dot-status.default {
  background-color: var(--color-neutral-light);
}
@media screen and (max-width: 768px) {
  .tracking-number-and-status {
    flex-wrap: wrap;
    gap: var(--spacing--extra-small);
  }
  .tracking-number-and-status .ant-divider {
    display: none;
  }
  .order-status-tracking {
    font-size: var(--font-paragraph);
  }
  .tracking-spot-info {
    padding: 0 var(--spacing-extra-small);
  }
}
.icon-timeline {
  font-size: 18px !important;
  margin-top: var(--spacing-small);
}
.icon-timeline.pending {
  color: var(--color-warning) !important;
}
.icon-timeline.approved {
  color: var(--color-success) !important;
}
.icon-timeline.updated {
  color: var(--color-secondary) !important;
}
.icon-timeline.cancel {
  color: var(--error-color) !important;
}
.icon-timeline.default {
  color: var(--color-neutral-light) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/viewRedemption/ViewRedemptionStyles.less"],"names":[],"mappings":"AAAA;EACE,iCAAA;EACA,8BAAA;AACF;AAEA;EACE,iCAAA;AAAF;AAGA;EACE,iCAAA;AADF;AAIA;EACE,aAAA;EACA,mBAAA;EACA,iCAAA;EACA,sBAAA;EACA,mBAAA;AAFF;AAKA;EACE,6BAAA;AAHF;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,WAAA;AAJF;AAOA;EACE,4BAAA;EACA,iBAAA;EACA,uCAAA;AALF;AAQA;EACE,4BAAA;EACA,gBAAA;EACA,uCAAA;AANF;AASA;EACE,iCAAA;AAPF;AAUA;EACE,6BAAA;AARF;AAWA;EACE,4BAAA;EACA,gCAAA;AATF;AAYA;EACE,yBAAA;EACA,6BAAA;AAVF;AAaA;EACE,yBAAA;AAXF;AAcA;EACE,gBAAA;AAZF;AAeA;EACE,mBAAA;AAbF;AAgBA;EACE,kCAAA;EACA,qBAAA;AAdF;AAYA;EAMM,sCAAA;AAfN;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAlBF;AAqBA;EACE,4BAAA;EACA,4BAAA;EACA,gBAAA;AAnBF;AAqBA;EACE,2CAAA;AAnBF;AAsBA;EACE,6CAAA;AApBF;AAuBA;EACE,+CAAA;AArBF;AAwBA;EACE,6CAAA;AAtBF;AAyBA;EACE,oCAAA;AAvBF;AA0BA;EACE,sCAAA;AAxBF;AA0BA;EACE,wCAAA;AAxBF;AA2BA;EACE,sCAAA;AAzBF;AA4BA;EACE,6BAAA;EACA,gCAAA;EACA,kCAAA;EACA,qCAAA;AA1BF;AA6BA;EACE,aAAA;EACA,sBAAA;AA3BF;AA8BA;EACE,oDAAA;EACA,2CAAA;EACA,6BAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,+BAAA;EACA,iCAAA;EACA,kBAAA;AA5BF;AA+BA;EACE,gBAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,gCAAA;AA7BF;AAgCA;EACE,iBAAA;EACA,kBAAA;EACA,4CAAA;AA9BF;AAiCA;EACE,gBAAA;EACA,4BAAA;EACA,6BAAA;AA/BF;AAkCA;EACE,gCAAA;EACA,iCAAA;AAhCF;AAmCA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjCF;AAoCA;EACE,4BAAA;EACA,gBAAA;AAlCF;AAqCA;EACE,kCAAA;EACA,qCAAA;AAnCF;AAsCA;EACE,WAAA;AApCF;AAuCA;EACE,8BAAA;AArCF;AAwCA;EACE,oCAAA;EACA,6CAAA;EACA,kCAAA;AAtCF;AAyCA;EACE,WAAA;EACA,4BAAA;EACA,2BAAA;EACA,mDAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAvCF;AA0CA;EACE,yCAAA;AAxCF;AA2CA;EACE,+CAAA;AAzCF;AA4CA;EACE,2CAAA;AA1CF;AA6CA;EACE,iDAAA;AA3CF;AA8CA;EACE,6CAAA;AA5CF;AA+CA;EACE,mDAAA;AA7CF;AAgDA;EACE,2CAAA;AA9CF;AAiDA;EACE,iDAAA;AA/CF;AAiDA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;AA/CF;AAiDA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EACA,8BAAA;AA/CF;AAiDA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gCAAA;AA/CF;AAiDA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA/CF;AAiDA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA/CF;AAiDA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AA/CF;AAiDA;EACE,+BAAA;EACA,8BAAA;EACA,mCAAA;EACA,gCAAA;EACA,iBAAA;EACA,+BAAA;EACA,2CAAA;EACA,gBAAA;EACA,WAAA;AA/CF;AAiDA;EACE,+BAAA;EACA,8BAAA;EACA,mCAAA;EACA,gCAAA;EACA,iBAAA;EACA,+BAAA;EACA,2CAAA;EACA,gBAAA;EACA,WAAA;AA/CF;AAiDA;EACE,gBAAA;AA/CF;AAiDA;EACE,4BAAA;EACA,2CAAA;EACA,4CAAA;EACA,6BAAA;AA/CF;AAgDE;EACE,+BAAA;EACA,gCAAA;EACA,iCAAA;EACA,gBAAA;AA9CJ;AAkDA;EACE,yBAAA;EACA,oBAAA;EACA,6BAAA;AAhDF;AAkDA;EACE,YAAA;EACA,oBAAA;EACA,6BAAA;AAhDF;AAoDA;EACE;IACE,aAAA;IACA,sBAAA;IACA,yBAAA;IACA,gBAAA;EAlDF;AACF;AAqDA;EACE;IACE,UAAA;EAnDF;EAsDA;IACE,UAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EApDF;AACF;AAuDA;EACE;IACE,gCAAA;EArDF;EAwDA;IACE,mCAAA;EAtDF;EAyDA;IACE,UAAA;EAvDF;EA0DA;IACE,UAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EAxDF;AACF;AA2DA;EAUE,iBAAA;EACA,gBAAA;EACA,2CAAA;AAlEF;AAqEE;EACE,UAAA;AAnEJ;AAsEE;EACE,sBAAA;EACA,kBAAA;AApEJ;AAuEE;EACE,yBAAA;EACA,kBAAA;AArEJ;AAyEE;EACE,sBAAA;AAvEJ;AAwCA;EAuCI,+BAAA;AA5EJ;AAqCA;EAyCM,2CAAA;EACA,4CAAA;AA3EN;AAiCA;EA8CM,yCAAA;AA5EN;AA8BA;EAmDI,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;AA9EJ;AAwBA;EAyDM,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AA9EN;AAkBA;EA+DM,2CAAA;AA9EN;AAeA;EAmEM,aAAA;EACA,mBAAA;EACA,yBAAA;AA/EN;AAUA;EAwEQ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA/ER;AACA;EAiFU,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AA/EV;AALA;EAwFQ,aAAA;EACA,sBAAA;EACA,gCAAA;EACA,uBAAA;EACA,uBAAA;AAhFR;AAZA;EA+FU,gCAAA;EACA,gBAAA;EACA,2CAAA;AAhFV;AAjBA;EAqGU,gCAAA;EACA,2BAAA;EACA,2CAAA;AAjFV;AAtBA;EA0GU,gCAAA;EACA,2BAAA;EACA,2CAAA;AAjFV;AA3BA;EA+GY,wCAAA;EACA,2BAAA;EACA,0BAAA;EACA,uCAAA;AAjFZ;AAjCA;EAsHY,2CAAA;EACA,2BAAA;AAlFZ;AArCA;EA2HU,2CAAA;EACA,gCAAA;EACA,2BAAA;AAnFV;AA1CA;EAgIY,wCAAA;EACA,uCAAA;EACA,2BAAA;AAnFZ;AA/CA;EAuIU,gCAAA;EACA,gBAAA;EACA,iCAAA;AArFV;AApDA;EA8IM,oCAAA;AAvFN;AAvDA;EAgJQ,gCAAA;EACA,2BAAA;EACA,2CAAA;AAtFR;AA5DA;EAuJM,aAAA;EACA,sBAAA;EACA,yBAAA;AAxFN;AAjEA;EA4JQ,gCAAA;EACA,2BAAA;EACA,2CAAA;AAxFR;AA6FA;EACE,gBAAA;EACA,kBAAA;AA3FF;AAyFA;EAKI,8BAAA;AA3FJ;AAsFA;EAWM,sCAAA;EACA,eAAA;AA9FN;AAkFA;EAiBI,yBAAA;AAhGJ;AA+EA;EAqBI,cAAA;AAjGJ;AA4EA;EAwBM,cAAA;EACA,0BAAA;AAjGN;AAuGA;EACE,eAAA;EACA,2BAAA;EACA,2CAAA;AArGF;AAyGE;EACE,sCAAA;AAvGJ;AAyGE;EACE,sCAAA;AAvGJ;AAyGE;EACE,wCAAA;AAvGJ;AAyGE;EACE,oCAAA;AAvGJ;AAyGE;EACE,sCAAA;AAvGJ;AA0GA;EACE,gCAAA;EACA,kDAAA;EACA,2BAAA;EACA,iCAAA;AAxGF;AA0GE;EACE,4CAAA;AAxGJ;AA4GA;EACE,eAAA;EACA,WAAA;AA1GF;AA6GA;EACE,kBAAA;AA3GF;AA8GA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,+BAAA;AA5GF;AAkHE;EACE,sCAAA;AAhHJ;AAkHE;EACE,sCAAA;AAhHJ;AAkHE;EACE,wCAAA;AAhHJ;AAkHE;EACE,oCAAA;AAhHJ;AAkHE;EACE,2CAAA;AAhHJ;AAwFA;EAgCI,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AArHJ;AAuHI;EACE,sCAAA;AArHN;AAuHI;EACE,sCAAA;AArHN;AAuHI;EACE,wCAAA;AArHN;AAuHI;EACE,oCAAA;AArHN;AAuHI;EACE,4CAAA;AArHN;AA+HA;EACE;IACE,eAAA;IACA,gCAAA;EA7HF;EA2HA;IAKI,aAAA;EA7HJ;EAgIA;IACE,gCAAA;EA9HF;EAiIA;IACE,qCAAA;EA/HF;AACF;AAmIA;EACE,0BAAA;EACA,gCAAA;AAjIF;AAmIE;EACE,sCAAA;AAjIJ;AAmIE;EACE,sCAAA;AAjIJ;AAmIE;EACE,wCAAA;AAjIJ;AAmIE;EACE,oCAAA;AAjIJ;AAmIE;EACE,4CAAA;AAjIJ","sourcesContent":[".container-view-redemption {\n  padding: 0 var(--spacing-regular);\n  margin-top: var(--spacing-big);\n}\n\n.container-title-view-redemption {\n  margin-bottom: var(--spacing-big);\n}\n\n.container-button-view-redemption {\n  margin-bottom: var(--spacing-big);\n}\n\n.container-subtitle-view-redemption {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: var(--spacing-big);\n  justify-content: start;\n  align-items: center;\n}\n\n.shipping-free-value {\n  color: var(--color-highlight);\n}\n\n.container-loading {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n  width: 100%;\n}\n\n.title-view-redemption {\n  font-size: var(--font-giant);\n  font-weight: bold;\n  color: var(--color-neutral-dark-darker);\n}\n\n.subtitle-view-redemption {\n  font-size: var(--font-giant);\n  font-weight: 500;\n  color: var(--color-neutral-dark-darker);\n}\n\n.container-summary-view-redemption {\n  margin-bottom: var(--spacing-big);\n}\n\n.text-view-redemption {\n  font-size: var(--font-medium);\n}\n\n.text-history-description {\n  color: var(--color-detached);\n  font-size: var(--font-paragraph);\n}\n\n.link-view-redemption {\n  color: #63717a !important;\n  font-size: var(--font-medium);\n}\n\n.link-view-redemption:hover {\n  color: #acc4d3 !important;\n}\n\n.font-weight-700 {\n  font-weight: 700;\n}\n\n.font-weight-bolder {\n  font-weight: bolder;\n}\n\n.spacing-icon {\n  margin-right: var(--spacing-small);\n  transform: scale(1.5);\n\n  span {\n    svg {\n      fill: var(--color-detached) !important;\n    }\n  }\n}\n\n.container-details-view-redemption {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.icon-pdf-orcament {\n  color: var(--color-detached);\n  font-size: var(--font-giant);\n  font-weight: 700;\n}\n.line-cancel {\n  border-color: var(--error-color) !important;\n}\n\n.line-pending {\n  border-color: var(--color-warning) !important;\n}\n\n.line-updated {\n  border-color: var(--color-secondary) !important;\n}\n\n.line-approved {\n  border-color: var(--color-success) !important;\n}\n\n.status-cancel {\n  color: var(--error-color) !important;\n}\n\n.status-pending {\n  color: var(--color-warning) !important;\n}\n.status-updated {\n  color: var(--color-secondary) !important;\n}\n\n.status-approved {\n  color: var(--color-success) !important;\n}\n\n.text-spot-not-found {\n  font-size: var(--font-medium);\n  color: var(--color-neutral-dark);\n  margin-top: var(--spacing-regular);\n  margin-bottom: var(--spacing-regular);\n}\n\n.container-spot-not-found {\n  display: flex;\n  flex-direction: column;\n}\n\n.container-history {\n  background-color: var(--color-neutral-light-lighter);\n  border-radius: var(--border-radius-primary);\n  padding: var(--spacing-small);\n  color: var(--color-secondary);\n  max-height: 350px;\n  overflow-y: auto;\n  padding: var(--spacing-regular);\n  margin-bottom: var(--spacing-big);\n  position: relative;\n}\n\n.history-status {\n  font-weight: 900;\n  width: 120px;\n  font-size: var(--font-medium);\n  white-space: nowrap;\n  margin-right: var(--spacing-big);\n}\n\n.container-history-date {\n  margin-left: 12px;\n  padding-left: 12px;\n  border-left: 1px solid var(--color-detached);\n}\n\n.text-history-date {\n  font-weight: 900;\n  color: var(--color-detached);\n  font-size: var(--font-medium);\n}\n\n.history-type {\n  font-size: var(--font-paragraph);\n  margin-left: var(--spacing-small);\n}\n\n.ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.text-total-value {\n  font-size: var(--font-giant);\n  font-weight: 700;\n}\n\n.container-total-value {\n  margin-top: var(--spacing-regular);\n  margin-bottom: var(--spacing-regular);\n}\n\n.button-view-redemption {\n  width: 100%;\n}\n\n.row-button {\n  margin-top: var(--spacing-big);\n}\n\n.history-timeline {\n  padding-bottom: var(--spacing-small);\n  border-left: 2px solid var(--color-secondary);\n  padding-left: var(--spacing-small);\n}\n\n.history-timeline:before {\n  content: '';\n  height: var(--spacing-small);\n  width: var(--spacing-small);\n  background-color: var(--color-secondary) !important;\n  border-radius: 50%;\n  position: absolute;\n  margin-left: -25px;\n}\n\n.history-timeline-cancel {\n  border-left: 2px solid var(--error-color);\n}\n\n.history-timeline-cancel:before {\n  background-color: var(--error-color) !important;\n}\n\n.history-timeline-pending {\n  border-left: 2px solid var(--color-warning);\n}\n\n.history-timeline-pending:before {\n  background-color: var(--color-warning) !important;\n}\n\n.history-timeline-updated {\n  border-left: 2px solid var(--color-secondary);\n}\n\n.history-timeline-updated:before {\n  background-color: var(--color-secondary) !important;\n}\n\n.history-timeline-approved {\n  border-left: 2px solid var(--color-success);\n}\n\n.history-timeline-approved:before {\n  background-color: var(--color-success) !important;\n}\n.col-total-value {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: end;\n}\n.title-terms-aprovation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: var(--spacing-small);\n  width: 100%;\n  margin: var(--spacing-small) 0;\n}\n.box-terms-aprovation-upload {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: var(--spacing-small);\n  margin-top: var(--spacing-small);\n}\n.modal-terms-aprovation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.box-terms-aprovation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.box-terms-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.button-view-redemption-danger {\n  height: var(--form-item-height);\n  padding: var(--button-padding);\n  max-height: var(--form-item-height);\n  font-size: var(--font-paragraph);\n  line-height: 120%;\n  font-family: var(--font-family);\n  border-radius: var(--border-radius-primary);\n  font-weight: 700;\n  width: 100%;\n}\n.button-view-redemption-warning {\n  height: var(--form-item-height);\n  padding: var(--button-padding);\n  max-height: var(--form-item-height);\n  font-size: var(--font-paragraph);\n  line-height: 120%;\n  font-family: var(--font-family);\n  border-radius: var(--border-radius-primary);\n  font-weight: 700;\n  width: 100%;\n}\n.modal-title {\n  font-weight: 600;\n}\n.modal-text-area {\n  min-height: 100px !important;\n  border-radius: var(--border-radius-primary);\n  border: 1px solid var(--color-neutral-light);\n  padding: var(--spacing-small);\n  &::placeholder {\n    font-family: var(--font-family);\n    font-size: var(--font-paragraph);\n    color: var(--color-neutral-light);\n    font-weight: 400;\n  }\n}\n\n.blocked-text {\n  background-color: #dcdcdc;\n  pointer-events: none;\n  text-decoration: line-through;\n}\n.row-undelivered {\n  opacity: 0.5;\n  pointer-events: none;\n  text-decoration: line-through;\n}\n\n//Mobile\n@media screen and (max-width: 768px) {\n  .col-total-value {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: end;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .container-history-status-date {\n    width: 50%;\n  }\n\n  .container-redemption-status {\n    width: 50%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .container-view-redemption {\n    margin-top: var(--spacing-small);\n  }\n\n  .container-title-view-redemption {\n    margin-bottom: var(--spacing-small);\n  }\n\n  .container-history-status-date {\n    width: 60%;\n  }\n\n  .container-redemption-status {\n    width: 40%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.modal-spot-tracking-wrapper {\n\n// Variáveis para personalização\n@scrollbar-width: 8px;\n@scrollbar-thumb-color: #888;\n@scrollbar-track-color: #f1f1f1;\n@scrollbar-thumb-hover-color: #555;\n@border-radius: var(--border-radius-primary);\n\n.ant-modal-content {\n  max-height: 600px;\n  overflow-y: auto;\n  border-radius: @border-radius;\n\n  // Personalizando a barra de rolagem\n  &::-webkit-scrollbar {\n    width: @scrollbar-width;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: @scrollbar-thumb-color;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: @scrollbar-track-color;\n    border-radius: 4px;\n  }\n\n  // Adicional: mudar a cor da barra de rolagem ao passar o mouse\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: @scrollbar-thumb-hover-color;\n  }\n}\n\n\n\n\n  .ant-modal-title {\n    padding: 0 var(--spacing-small);\n    .modal-title-spot-tracking {\n      font-size: var(--font-paragraph) !important;\n      color: var(--color-neutral-light) !important;\n    }\n\n    .ant-divider-horizontal {\n      margin: var(--spacing-small) 0 !important;\n    }\n  }\n\n  .container-modal-spot-tracking {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-small);\n    padding: 0 var(--spacing-small);\n\n    .tracking-number-and-status {\n      display: flex;\n      flex-direction: row;\n      justify-content: flex-start;\n      align-items: center;\n    }\n    .order-number {\n      color: var(--color-neutral-dark) !important;\n    }\n\n    .tracking-infos {\n      display: flex;\n      flex-direction: row;\n      gap: var(--spacing-small);\n\n      .tracking-spot-info {\n        width: 56px;\n        height: 56px;\n        border-radius: 50%;\n        border: 1px solid var(--color-neutral-light);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        img {\n          object-fit: cover;\n          overflow: hidden;\n          max-width: 100%;\n          max-height: 100%;\n        }\n      }\n      .tracking-spot-info-details {\n        display: flex;\n        flex-direction: column;\n        gap: var(--spacing--extra-small);\n        justify-content: center;\n        align-items: flex-start;\n\n        .tracking-spot-info-title {\n          font-size: var(--font-paragraph);\n          font-weight: 700;\n          color: var(--color-neutral-dark) !important;\n        }\n\n        .item-vendor {\n          font-size: var(--font-paragraph);\n          font-weight: 400 !important;\n          color: var(--color-neutral-dark) !important;\n        }\n        .item-code {\n          font-size: var(--font-paragraph);\n          font-weight: 700 !important;\n          color: var(--color-neutral-dark) !important;\n\n          .item-code-link {\n            color: var(--color-highlight) !important;\n            font-weight: 400 !important;\n            text-decoration: underline;\n            margin-left: var(--spacing-extra-small);\n          }\n\n          .item-code-text {\n            color: var(--color-neutral-dark) !important;\n            font-weight: 400 !important;\n          }\n        }\n        .item-shipping-value {\n          color: var(--color-neutral-dark) !important;\n          font-size: var(--font-paragraph);\n          font-weight: 700 !important;\n\n          span {\n            color: var(--color-highlight) !important;\n            margin-left: var(--spacing-extra-small);\n            font-weight: 500 !important;\n          }\n        }\n\n        .tracking-spot-info-subtitle {\n          font-size: var(--font-paragraph);\n          font-weight: 400;\n          color: var(--color-neutral-light);\n        }\n      }\n    }\n    .tracking-delivery-forecast {\n      margin: var(--spacing-extra-small) 0;\n      .delivery-forecast-title {\n        font-size: var(--font-paragraph);\n        font-weight: 700 !important;\n        color: var(--color-neutral-dark) !important;\n      }\n    }\n\n    .tracking-details {\n      display: flex;\n      flex-direction: column;\n      gap: var(--spacing-small);\n\n      .tracking-details-title {\n        font-size: var(--font-paragraph);\n        font-weight: 700 !important;\n        color: var(--color-neutral-dark) !important;\n      }\n    }\n  }\n}\n.timeline {\n  background: #fff;\n  border-radius: 8px;\n\n  .timeline-item{\n    margin: var(--spacing-small) 0;\n  }\n  \n\n  .ant-timeline-item-head-green {\n    .timeline-icon-success {\n      color: var(--color-success) !important;\n      font-size: 16px;\n    }\n  }\n\n  .ant-timeline-item-head-gray {\n    background-color: #d9d9d9;\n  }\n\n  .ant-timeline-item-content {\n    color: #bfbfbf;\n\n    .timeline-title {\n      color: #bfbfbf;\n      font-size: 14px !important;\n    }\n    \n  }\n}\n\n.timeline-title {\n  font-size: 16px;\n  font-weight: 700 !important;\n  color: var(--color-neutral-dark) !important;\n\n\n\n  &.pending {\n    color: var(--color-warning) !important;\n  }\n  &.approved {\n    color: var(--color-success) !important;\n  }\n  &.updated {\n    color: var(--color-secondary) !important;\n  }\n  &.cancel {\n    color: var(--error-color) !important;\n  }\n  &.default {\n    color: var(--color-success) !important;\n  }\n}\n.timeline-description {\n  font-size: var(--font-paragraph);\n  color: var(--color-neutral-dark-darker) !important;\n  font-weight: 500 !important;\n  margin-left: var(--spacing-small);\n\n  &.default {\n    color: var(--color-neutral-light) !important;\n  }\n}\n\n.timeline-date {\n  font-size: 14px;\n  color: #888;\n}\n\n.visible-hidden-tracking {\n  visibility: hidden;\n}\n\n.order-status-tracking {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0 var(--spacing-small);\n\n  \n  \n  \n\n  &.pending {\n    color: var(--color-warning) !important;\n  }\n  &.approved {\n    color: var(--color-success) !important;\n  }\n  &.updated {\n    color: var(--color-secondary) !important;\n  }\n  &.cancel {\n    color: var(--error-color) !important;\n  }\n  &.default {\n    color: var(--color-neutral-dark) !important;\n  }\n\n\n\n\n\n  .dot-status {\n    content: '';\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n\n    &.pending {\n      background-color: var(--color-warning);\n    }\n    &.approved {\n      background-color: var(--color-success);\n    }\n    &.updated {\n      background-color: var(--color-secondary);\n    }\n    &.cancel {\n      background-color: var(--error-color);\n    }\n    &.default {\n      background-color: var(--color-neutral-light);\n    }\n  }\n\n\n\n\n\n}\n\n@media screen and (max-width: 768px) {\n  .tracking-number-and-status{\n    flex-wrap: wrap;\n    gap: var(--spacing--extra-small);\n\n    .ant-divider{\n      display: none;\n    }\n  }\n  .order-status-tracking {\n    font-size: var(--font-paragraph);\n  }\n\n  .tracking-spot-info{\n    padding: 0 var(--spacing-extra-small);\n\n  }\n}\n\n.icon-timeline {\n  font-size: 18px !important;\n  margin-top: var(--spacing-small);\n\n  &.pending {\n    color: var(--color-warning) !important;\n  }\n  &.approved {\n    color: var(--color-success) !important;\n  }\n  &.updated {\n    color: var(--color-secondary) !important;\n  }\n  &.cancel {\n    color: var(--error-color) !important;\n  }\n  &.default {\n    color: var(--color-neutral-light) !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
